import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface CustomTemplatesApprovalSettingProps {
  defaultEnabled: boolean | null;
}

const CustomTemplatesApprovalsSetting: FunctionComponent<CustomTemplatesApprovalSettingProps> = ({
  defaultEnabled
}) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled || false}
    description={bfTranslate('Customized templates must be approved by an administrator before end users are able to download or save to Brandfolder')}
    errorTitle={bfTranslate('Error updating custom templates approval setting. Please contact support.')}
    id="custom-templates-approvals-required"
    successTitle={bfTranslate('Custom templates approval setting updated!')}
    title={bfTranslate('Require administrator approval on custom templates')}
    updateResourceKey="customTemplatesApprovalsRequired"
  />
);

export default CustomTemplatesApprovalsSetting;
